function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2582",
    transform: "translate(-1068 -521)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 546",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1068 521)",
    style: {
      fill: "#eb4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3422",
    d: "M140.01 108.776a8.443 8.443 0 0 0-.208-2.015h-9.252v3.657h5.431a4.816 4.816 0 0 1-2.015 3.2l-.018.122 2.925 2.26.2.02a9.635 9.635 0 0 0 2.934-7.248",
    transform: "translate(953.647 428.444)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3423",
    d: "M22.728 164.275a9.392 9.392 0 0 0 6.526-2.387l-3.11-2.409a5.832 5.832 0 0 1-3.416.985 5.932 5.932 0 0 1-5.606-4.095l-.116.01-3.042 2.354-.04.111a9.847 9.847 0 0 0 8.8 5.431",
    transform: "translate(1061.469 382.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3424",
    d: "M4.248 77.732a6.067 6.067 0 0 1-.328-1.949 6.375 6.375 0 0 1 .317-1.949l-.005-.134-3.08-2.392-.1.048a9.833 9.833 0 0 0 0 8.847l3.2-2.474",
    transform: "translate(1074.343 461.217)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3425",
    d: "M22.728 3.81a5.461 5.461 0 0 1 3.81 1.467l2.781-2.715A9.468 9.468 0 0 0 22.728 0a9.847 9.847 0 0 0-8.8 5.431l3.186 2.475a5.957 5.957 0 0 1 5.614-4.096",
    transform: "translate(1061.469 527.146)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.87ec239e8b70902f723ba9f5ec9a512a.svg";
export { ForwardRef as ReactComponent };